import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppState, Store } from 'app/store/states/app.state';
import { map } from 'rxjs/operators';

@Component({
  selector: 'spinner-component',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})

export class SpinnerComponent implements OnInit {
  isLoading: Observable<boolean>;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.isLoading = this.store.select('loading').pipe(
      map(loadingState => loadingState.showLoading)
    )
  }
}
